import { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { ToastContext } from '../../../../contexts/toast.context';
import Button from '../../../reusable/button/button.component';
import Spinner from '../../../reusable/spinner/spinner.component';

import Client from '../../../../tools/client';

import {
  ContentContainer,
  Input,
  Label,
  MainContainer,
  Textarea,
  Title
} from '../../../../styles/component.styles';

const client = new Client();

const AddPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [pageTypes, setPageTypes] = useState([]);
  const [pageTypeId, setPageTypeId] = useState(null);

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    const fetchPageTypes = async () => {
      const res = await client.getPageTypes();
      if (Array.isArray(res)) {
        setPageTypes(
          res.map((pt) => ({
            value: pt.id,
            label: pt.name
          }))
        );
      }
    };
    fetchPageTypes();
  }, []);

  const submit = async () => {
    if (!title) return errorToast('Title is required');
    if (!pageTypeId) return errorToast('Please select a Page Type');

    setLoading(true);

    const data = {
      title,
      description,
      pageTypeId: pageTypeId.value
    };

    const res = await client.createPage(data);

    if (res.status === 400) {
      errorToast(res.message);
      setLoading(false);
      return;
    }

    successToast('Page Created');
    navigate(`/content-management/pages/${res.id}`);
  };

  return (
    <MainContainer>
      {loading ? (
        <Spinner />
      ) : (
        <ContentContainer>
          <Title>Add New Page</Title>

          <Input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title *"
          />

          {pageTypes.length > 0 && (
            <>
              <Label>Page Type *</Label>
              <div style={{ marginBottom: '16px' }}>
                <Select
                  options={pageTypes}
                  value={pageTypeId}
                  onChange={(selected) => setPageTypeId(selected)}
                  placeholder="Select Page Type"
                  isSearchable
                />
              </div>
            </>
          )}

          {/* <Label>Description</Label>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional short description"
          /> */}

          <Button onClick={submit}>Create</Button>
        </ContentContainer>
      )}
    </MainContainer>
  );
};

export default AddPage;